export const headingLinkClicked = (ctaText, headerText = '') => ({
  type: 'Heading Link Clicked',
  data: {
    cta_text: ctaText,
    component_heading: headerText,
  },
});
